export enum SaveMapViewFieldName {
  Name = 'name',
  Description = 'description',
}
